import { axiosInstance } from './ApiConfig';

async function FetchCalculations(inputs, calculations) {
  try {
    const processedInputs = Object.fromEntries(
      Object.entries(inputs).map(([key, value]) =>
        value === '' ? [key, null] : [key, value]
      )
    );
    const request = JSON.stringify({
      input: processedInputs,
      calculations: calculations,
    });

    const response = await axiosInstance({
      method: 'POST',
      url: '/calculations',
      data: request,
    });

    if (response.status === 200) {
      return response.data.value;
    }

    const errorMessage = `Unexpected status code: ${response.status}`;
    throw new Error(errorMessage);
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;
      const errorMessage =
        (data && data.detail) || `Request failed with status ${status}`;
      throw new Error(errorMessage);
    } else if (error.request) {
      throw new Error('Network error: No response from server');
    } else {
      throw new Error('Request failed: ' + error.message);
    }
  }
}

export default FetchCalculations;
